'use client';

import { useMutation } from '@tanstack/react-query';

import { Auth } from '@air/api';
import { reportErrorToBugsnag } from '@air/utils-error';

/**
 * Resend verification email for plugin verify-user surfaces.
 * Uses Auth.verifyEmail (not the pending-email / email-change mutation).
 */
export const useVerifyEmailResend = () =>
  useMutation({
    mutationFn: () => Auth.verifyEmail(),
    onError: (error) => {
      reportErrorToBugsnag({
        context: 'Failed to resend verification email',
        error,
      });
    },
  });
